// extracted by mini-css-extract-plugin
export var cardHeader = "_f3-0";
export var reorderHandle = "_f3-3";
export var titleArea = "_f3-1";
export var titleAreaWithHandle = "_f3-2";